import { inject } from "vue";
import { ProcessingError, UploadError } from "@/modules/internal_api/image";

export const useErrorMessageHandler = () => {
  const isMissingTranslation = (translatedMessage: string): boolean => {
    return /\[missing ".*?" translation\]/.test(translatedMessage);
  };

  const errorMessageMap = {
    original_source_url_is_invalid: "upload_widget.invalid_image_url",
    upload_error: "editor.error.failed_to_download_image_from_url.message",
  };

  const I18n = inject("I18n", window.I18n);

  // // Type guard functions
  // static isUploadError(upload: Upload | UploadError): upload is UploadError {
  //   return upload.state === UploadState.Error;
  // }

  // static isProcessingError(result: ResultData | ProcessingError): result is ProcessingError {
  //   return result.state === ProcessingState.Error;
  // }

  const getErrorMessage = (error: UploadError | ProcessingError, defaultMessage = ""): string => {
    const originalTranslation = I18n.t(`editor.error.${error.message}.message`);
    if (!isMissingTranslation(originalTranslation)) {
      return originalTranslation;
    }

    if (errorMessageMap[error.message]) {
      return I18n.t(errorMessageMap[error.message]);
    }

    if (error.code.includes("upload_error")) {
      return I18n.t(errorMessageMap["upload_error"]);
    }
    return defaultMessage;
  };

  const getErrorHeading = (error: UploadError | ProcessingError): string => {
    return getErrorMessage(error, I18n.t("ai_brush.error.sorry_something_went_wrong_please_try_again_later"));
  };
  return { getErrorHeading, getErrorMessage };
};
